jQuery(document).ready(function ($) {
	
	// ANCHOR Filtre par marques
	$("#basic").multiselect({
		templates: {
			li: '<li><div class="checkbox"><label></label></div></li>',
		},
		nonSelectedText: "Filtrer par marques...",
		nSelectedText: "marques sélectionnées",
		allSelectedText: "Sélection complète",
		maxHeight: 200,
		onChange: function (option, checked, select) {

			if (checked === true) {
				addCustomFilterTag(option.val());
			} else {
				$("[data-manufacturer-id='" + option.val() + "']").remove();
			}

			setFilters();
		},
	});

	// ANCHOR Filtre par pertinence, prix croissant ou décroissant
	$("#single_select").multiselect({
		templates: {
			li: '<li><a href="javascript:void(0);"><label></label></a></li>',
		},

		onInitialized: function (select, container) {
			container.find("input[type=radio]").addClass("d-none"); // hide radio
		},

		onChange: function (option, checked, select) {
			setFilters();
		},
	});

	$(".multiselect-container div.checkbox").each(function (index) {
		var id = "multiselect-" + index,
			$input = $(this).find("input");

		// Associate the label and the input
		$(this).find("label").attr("for", id);
		$input.attr("id", id);

		// Remove the input from the label wrapper
		$input.detach();

		// Place the input back in before the label
		$input.prependTo($(this));

		$(this).on("click touch", function (e) {
			// Prevents the click from bubbling up and hiding the dropdown
			e.stopPropagation();
		});
	});

	$("#reset-all").on("click touch", function () {
		$("#products_list").css("opacity", "0.4");
		
		let order_by = $("select#single_select").val().split("_")[0];
		let order_way = $("select#single_select").val().split("_")[1];

		jHash.val({
			order_by: order_by,
			order_way: order_way,
		});

		$('#products_list .product-item').each( (index, bikeContainer) => {
			$(bikeContainer).show();
		});

		filterByPrice("position");

		$("#tags").empty();
		$("#reset-all").addClass("invisible");
		$(".selected_manufacturers").multiselect("deselectAll", false);
		$(".selected_manufacturers").multiselect("updateButtonText");

		$("#products_list").css("opacity", "1");
	});

	$("#tags").on("click touch", "[data-manufacturer-id]", function () {
		var manufacturer_id = $(this).data("manufacturer-id");
		$(".selected_manufacturers").multiselect(
			"deselect",
			manufacturer_id,
			true
		);
		$("[data-manufacturer-id='" + manufacturer_id + "']").remove();
	});

	$(".nb_products").removeClass("invisible");
	updateNbCount();

	//Full screen menu filtre

	$("#target-open").on("click touch", function () {
		$("#menu-search")
			.addClass("opened")
			.one(
				"webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
			);
	});

	$("#target-close").on("click touch", function () {
		$("#menu-search")
			.removeClass("opened")
			.one(
				"webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
			);
	});

	$("#valider").on("click touch", function () {
		$("#menu-search")
			.removeClass("opened")
			.one(
				"webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
			);

		$("#products_list").css("opacity", "0.4");

		setTimeout(function () {
			$("#products_list").css("opacity", "1");
		}, 600);
	});
	// End Full screen menu filtre
	
	// ANCHOR Chargement des filtres de l'url
	if (jHash.val("stock_only")) {
		$("#stock-filter-input").prop("checked", true);
	}

	if (jHash.val("selected_manufacturers") && /^[0-9\,]*$/.test(jHash.val("selected_manufacturers"))) {
		var selected_manufacturers_array = jHash
			.val("selected_manufacturers")
			.split(",");

		for (var i = 0; i < selected_manufacturers_array.length; i++) {
			if ( $( '.selected_manufacturers option[value="' + selected_manufacturers_array[i] + '"]' ).text() ) {
				$(".selected_manufacturers").multiselect(
					"select",
					selected_manufacturers_array[i]
				);

				addCustomFilterTag(selected_manufacturers_array[i]);
			}
		}
	}

	if (jHash.val("order_by") && jHash.val("order_way")) {
		$("#single_select").multiselect(
			"select",
			jHash.val("order_by") + "_" + jHash.val("order_way"),
			true
		);
	}

	if( $("#menu-search").length ){
		setFilters();
	}

	// Gestionnaire d'événement pour l'événement de changement sur #stock-filter-input
	$("#stock-filter-input").on("change", function () {
		setFilters();
	});

	// ANCHOR Get stock status when element is visible on scroll
	const productItems = document.querySelectorAll('#products_list .product-item');

	// Options for the Intersection Observer
	const intersectionObserveroOptions = {
		root: null, // Use the viewport as the root
		rootMargin: '0px', // No margin
		threshold: 0.3, // Trigger when 30% of the element is visible
	};

	// Intersection Observer callback function
	const callback = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				assignStockForProduct(entry.target.getAttribute('data-productid'));
				observer.unobserve(entry.target);
			}
		});
	};

	// Create the Intersection Observer instance
	const observer = new IntersectionObserver(callback, intersectionObserveroOptions);

	// Start observing each product element
	productItems.forEach((element) => {
		observer.observe(element);
	});
});

$("#collapseRowVelo").on("shown.bs.collapse", function () {
	$("#moreBikes a").hide();
	let bikeItems = $("#collapseRowVelo .row").children().detach();
	$('#products_list').append(bikeItems);
	$('#collapseRowVelo').remove();
});

//Hover bloc section découvrez aussi

$(".bloc-decouvrez-aussi .survol-1").hover(
	function () {
		$("#bloc1").addClass("background-white-hover");
		$("#bloc1 .icon").addClass("icon-red-hover");
		$("#bloc1  a").addClass("txt-red-hover");
		$("#bloc1 .btn-round-lg").addClass("btn-red-hover");
	},
	function () {
		$("#bloc1").removeClass("background-white-hover");
		$("#bloc1 .icon").removeClass("icon-red-hover");
		$("#bloc1  a").removeClass("txt-red-hover");
		$("#bloc1 .btn-round-lg").removeClass("btn-red-hover");
	}
);

$(".bloc-decouvrez-aussi .survol-2").hover(
	function () {
		$("#bloc2").addClass("background-white-hover");
		$("#bloc2 .icon").addClass("icon-red-hover");
		$("#bloc2  a").addClass("txt-red-hover");
		$("#bloc2 .btn-round-lg ").addClass("btn-red-hover");
	},
	function () {
		$("#bloc2").removeClass("background-white-hover");
		$("#bloc2 .icon").removeClass("icon-red-hover");
		$("#bloc2  a").removeClass("txt-red-hover");
		$("#bloc2 .btn-round-lg").removeClass("btn-red-hover");
	}
);

$(".bloc-decouvrez-aussi .survol-3").hover(
	function () {
		$("#bloc3").addClass("background-white-hover");
		$("#bloc3 .icon").addClass("icon-red-hover");
		$("#bloc3  a").addClass("txt-red-hover");
		$("#bloc3 .btn-round-lg ").addClass("btn-red-hover");
	},
	function () {
		$("#bloc3").removeClass("background-white-hover");
		$("#bloc3 .icon").removeClass("icon-red-hover");
		$("#bloc3  a").removeClass("txt-red-hover");
		$("#bloc3 .btn-round-lg").removeClass("btn-red-hover");
	}
);

$(".bloc-decouvrez-aussi .survol-4").hover(
	function () {
		$("#bloc4").addClass("background-white-hover");
		$("#bloc4 .icon").addClass("icon-red-hover");
		$("#bloc4  a").addClass("txt-red-hover");
		$("#bloc4 .btn-round-lg ").addClass("btn-red-hover");
	},
	function () {
		$("#bloc4").removeClass("background-white-hover");
		$("#bloc4 .icon").removeClass("icon-red-hover");
		$("#bloc4  a").removeClass("txt-red-hover");
		$("#bloc4 .btn-round-lg").removeClass("btn-red-hover");
	}
);

$(".bloc-decouvrez-aussi .survol-5").hover(
	function () {
		$("#bloc5").addClass("background-white-hover");
		$("#bloc5 .icon").addClass("icon-red-hover");
		$("#bloc5  a").addClass("txt-red-hover");
		$("#bloc5 .btn-round-lg ").addClass("btn-red-hover");
	},
	function () {
		$("#bloc5").removeClass("background-white-hover");
		$("#bloc5 .icon").removeClass("icon-red-hover");
		$("#bloc5  a").removeClass("txt-red-hover");
		$("#bloc5 .btn-round-lg").removeClass("btn-red-hover");
	}
);
//End Hover bloc section découvrez aussi

// ANCHOR Fonction pour assigner l'état de stock à un produit
function assignStockForProduct(id_bike) {
	return new Promise(function (resolve, reject) {
		let bikeContainer = $(`.product-item[data-productid="${id_bike}"]`).first();
		if ( bikeContainer && typeof $(bikeContainer).data("stock") == "undefined" ) {
			let id_manufacturer = $(bikeContainer).attr("data-manufacturer");
			let stock_api_url =
				"https://www.cyclable.com/module/selectstorebystock/getstock?action=getStockState&ajax=true&id_product=" + id_bike +
				"&id_manufacturer=" + id_manufacturer +
				"&id_warehouse=" + id_warehouse;
			let stock_state = 0;

			$(bikeContainer).find(".stock-indication .content-placeholder").show();

			$.ajax({
				url: stock_api_url,
				type: "GET",
				dataType: "json",
				success: function (response) {
					$(bikeContainer).find(".stock-indication .content-placeholder").hide();
					if (response && response["stock_in_warehouse"]) {
						stock_state = 1;
						$(bikeContainer)
							.find(".stock-indication .in-stock")
							.show().css("display", "flex");
					} else if(response && (response["stock_supermodel"] || response["stock_test"])){
						stock_state = 2;
						$(bikeContainer).find(".stock-indication .stock-test")
							.show().css("display", "flex");
					} else if(response && response["stock_in_siblings_warehouses"] && Object.keys(response["stock_in_siblings_warehouses"]).length > 0) {
						stock_state = 3;
						$(bikeContainer).find(".stock-indication .stock-retrait")
							.show().css("display", "flex");
					} else {
						stock_state = 0;
						$(bikeContainer).find(".stock-indication .no-stock").show();
					}

					$(bikeContainer).find(".stock-indication .content-placeholder").hide();
					$(bikeContainer).attr("data-stock", stock_state);

					resolve(); // Résoudre la promesse après la fin de l'appel AJAX
				}
			});
		} else {
			resolve(); // Résoudre la promesse si le stock est déjà attribué
		}
	});
}

// Récupérer la valeur de certains cookies
function getCookieValue(name) {
	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i].trim();
		if (cookie.indexOf(name + "=") === 0) {
			return cookie.substring(name.length + 1, cookie.length);
		}
	}
	return null;
}

// ANCHOR Filtrer par état de stock
function filterByStock(state){
	// Parcours de chaque élément de produit sans l'attribut data-stock
	$("#products_list .product-item:not('.hidden-by-manufacturer')").each( (index, bikeContainer) => {
		var dataStock = $(bikeContainer).attr('data-stock');
		if( typeof dataStock == "undefined" && state ) {
			$(bikeContainer).css("opacity", "0.4");
			// Appel de assignStockForProduct et stockage de la promesse retournée
			var promise = assignStockForProduct(
				$(bikeContainer).attr("data-productid")
			);

			promise.then(function() {
				dataStock = $(bikeContainer).attr('data-stock');
				if( !state ){
					$(bikeContainer).removeClass("hidden-by-stock");
				} else {
					if( dataStock > 0) {
						$(bikeContainer).removeClass("hidden-by-stock");
					} else {
						$(bikeContainer).addClass("hidden-by-stock");
					}
				}
				$(bikeContainer).css("opacity", "1");
			});
		} else {
			if( !state ){
				$(bikeContainer).removeClass("hidden-by-stock");
			} else {
				if( dataStock > 0) {
					$(bikeContainer).removeClass("hidden-by-stock");
				} else {
					$(bikeContainer).addClass("hidden-by-stock");
				}
			}
		}

		updateNbCount();
	});
}

// ANCHOR Filtrer par ID de marque
function filterByManufacturer(manufacturer_array){
	$('#products_list .product-item').each( (index, bikeContainer) => {
		// On récupère l'identifiant du fabricant sur l'objet
		let bikeManufacturer = $(bikeContainer).data('manufacturer');
		if(manufacturer_array.length && bikeManufacturer){
			// Si l'ID du fabricant du produit est dans la liste des filtres sélectionnés
			if(manufacturer_array.includes( bikeManufacturer.toString() )) {
				// Marque du vélo dans la liste
				$(bikeContainer).removeClass("hidden-by-manufacturer");
			} else {
				// Marque du vélo pas dans la liste
				$(bikeContainer).addClass("hidden-by-manufacturer");
			}
		} else {
			// Si aucune marque n'est sélectionnée ou si le vélo n'a pas de marque, on affiche
			$(bikeContainer).removeClass("hidden-by-manufacturer");
		}
	});
}

// ANCHOR Filtrer par prix ASC ou DESC, ou par rien
function filterByPrice(order_by, order_way = null){
	let productItems = $('#products_list .product-item');

	if( order_by == "position" ){
		// On retire la propriété CSS Order pour réinitialiser l'ordre 
		productItems.each(function(index) {
			$(this).css("order", 'inherit');
		});
	} else if ( order_by == "price" ) {
		if( order_way == "asc" ) {
			productItems.sort(function(a, b) {
				const priceA = parseInt($(a).data("price"));
				const priceB = parseInt($(b).data("price"));
				return priceA - priceB;
			});
		} else {
			productItems.sort(function(a, b) {
				const priceA = parseInt($(a).data("price"));
				const priceB = parseInt($(b).data("price"));
				return priceB - priceA;
			});
		}

		// On définit l'ordre via du CSS pour éviter trop de chargement JS
		productItems.each(function(index) {
			$(this).css("order", index + 1);
		});
	}
}

// ANCHOR Redéfinie les paramètres dans l'url 
function setFilters(){
	// On réduit l'opacité de la liste pour indiquer le chargement 
	$("#products_list").css("opacity", "0.4");

	// Filtre par stock
	let stock_only = $("#stock-filter-input").is(":checked");

	// Filte par prix et ordre 
	let order_by = $("select#single_select").val().split("_")[0];
	let order_way = $("select#single_select").val().split("_")[1];

	// Filtres par marque
	let selected_manufacturers_array = $("select.selected_manufacturers").val() || [];
	let selected_manufacturers_filters = selected_manufacturers_array.join(",");

	// Définit l'URL
	let urlFilters = {};
	if(order_by && order_by != "position" ) urlFilters.order_by = order_by;
	if(order_way && order_by != "position") urlFilters.order_way = order_way;
	if(stock_only) urlFilters.stock_only = stock_only;
	if(selected_manufacturers_filters) urlFilters.selected_manufacturers = selected_manufacturers_filters;

	// S'il n'y avait aucun filtres avant et aucun de pré-selectionné, on ne modifie pas l'url 
	if(Object.keys(urlFilters).length || Object.keys(jHash.val()).length) {
		jHash.val(urlFilters);
		$('html,body').scrollTop($("#menu-search").offset().top - 50);
	}

	// On affiche tous les vélos 
	if(Object.keys(urlFilters).length) {
		$("#moreBikes a").hide();
		let bikeItems = $("#collapseRowVelo .row").children().detach();
		$('#products_list').append(bikeItems);
		$('#collapseRowVelo').remove();
	}

	filterByManufacturer(selected_manufacturers_array);
	filterByPrice(order_by, order_way);
	filterByStock(stock_only);

	// On retire l'effet de chargement
	$("#reset-all").removeClass("invisible");
	updateNbCount();
	$("#valider").addClass("blink");

	setTimeout(function () {
		$("#valider").removeClass("blink");

		if( !$(".product-item:visible").length ){
			$('#no-bikes-displayed').show();
		} else {
			$('#no-bikes-displayed').hide();
		}
	}, 600);

	$("#products_list").css("opacity", "1");
}

function addCustomFilterTag(option){
	$("#tags").append(
		'<div class="d-flex bg-gray rounded mr-2 mb-2 align-items-center" data-manufacturer-id="' + option + '"> <div class="d-flex align-items-center justify-content-center"> <svg class="mr-2" width="10" height="10"> <g id="Menu_Close_hover" fill="#303028" fill-rule="nonzero"> <path d="M9.66045453,8.78232557 L5.9640909,5 L9.66045453,1.21767442 C9.9265909,0.945348837 9.92681817,0.503488373 9.66045453,0.230930233 C9.3940909,-0.041395349 8.9625,-0.041395349 8.69636363,0.230930233 L5,4.0132558 L1.30363636,0.231162791 C1.0375,-0.0411627907 0.60590909,-0.0411627907 0.339545453,0.231162791 C0.0731818183,0.50372093 0.073409091,0.945581397 0.339545453,1.21790698 L4.0359091,5 L0.339545453,8.78232557 C0.0731818183,9.05488373 0.0731818183,9.49627907 0.339545453,9.7688372 C0.60590909,10.0413953 1.0375,10.0413953 1.30386364,9.7688372 L5,5.98651163 L8.69636363,9.7688372 C8.96272727,10.0413953 9.3940909,10.0413953 9.66045453,9.7688372 C9.92681817,9.49627907 9.92681817,9.05488373 9.66045453,8.78232557 Z" id="Shape"></path> </g> </svg> </div> <div class="text text-s-xs text-uppercase">' 
			+ $('.selected_manufacturers option[value="' + option + '"]').text() +
		"</div> </div>"
	);
}

function updateNbCount(){
	var visibleProductCount = $(".product-item:visible").length;
	var productText = (visibleProductCount > 0) ? visibleProductCount + " vélo" + ( visibleProductCount > 1 ? "s" : "") : "les vélos";

	$(".nb_products").text(visibleProductCount + " vélo" + ( visibleProductCount > 1 ? "s" : ""));
	$("#valider").text("Voir " + productText);
}